import React, { Component } from "react";

import SpaceCasino from "../../images/logo-space.svg";
import SpaceCasino2 from "../../images/logo-space2.svg";

import Logos from "../../files/SpaceCasinoLogo.zip";


class Marketing extends Component {
  render() {
    return (
      <section className="clearfix fadeInUp marketing">
        <div className="container">
          <div className="title-1">Marketing Tools</div>
          <div className="content">
            <p>
              There is a wide selection of marketing tools which can be used to build a tailored scheme.
            </p>
          </div>
          <div className="row">
            <div className="col">
              <div className="lf">
                <h3>Offers</h3>
              </div>
              <div className="rt">
                <table className="clearfix">
                  <tbody>
                    <tr>
                      <td>
                        <span>Available Market</span>
                        <strong>UK</strong>
                      </td>
                      <td>
                        <span>Brands</span>
                        SpaceCasino.co.uk
                      </td>
                    </tr>
                    <tr>
                      <td>
                        <strong>Casino</strong>
                      </td>
                      <td>Make your first deposit and you get 10 spins each day for the following 7 days</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div className="col">
              <div className="lf">
                <h3>Our logo</h3>
              </div>
              <div className="rt">
                <p>
                  Our logo refers to space travel just as our brand name does. There are two versions of the logo applicable to darker and lighter backgrounds.
                </p>
                <p>
                  We use the reversed version of the logo when placing it on a
                  darker background.
                </p>
                <p>
                  Download <a href={Logos} title="Logos" target="_blank" rel="noopener noreferrer">EPS</a> or{" "}
                  <a href={Logos} title="Logos" target="_blank" rel="noopener noreferrer">PNG</a> files.
                </p>
                <div className="logos">
                  <span>
                    <img
                      src={SpaceCasino2}
                      title="SpaceCasino"
                      alt="SpaceCasino"
                    />
                  </span>
                  <span>
                    <img
                      src={SpaceCasino}
                      title="SpaceCasino"
                      alt="SpaceCasino"
                    />
                  </span>
                </div>
              </div>
            </div>

            <div className="col">
              <div className="lf">
                <h3>ScreenShots</h3>
              </div>
              <div className="rt">
                <p>
                  The bundle of screenshots are available for promo use. Specific screenshots for a certain purpose can always be requested and will be provided.
                </p>
                <p>
                  Download <a href="https://res.cloudinary.com/mv/raw/upload/v1559036391/files/assets/ScreenShots.zip" title="ScreenShots" target="_blank" rel="noopener noreferrer">PNG</a> files.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Marketing;
